import debounce from 'lodash.debounce';

import { isUserExisting } from './useRequest';

export const checkEmailStatus = async (email: string, cbFunc?: Function) => {
  const result = await isUserExisting(email);
  const emailHasBeenUsed = 'response' in result ? result.response.data : false;
  return cbFunc ? cbFunc(emailHasBeenUsed) : emailHasBeenUsed;
};

export const debounceCheckEmailStatus = debounce(checkEmailStatus, 300);
